import { render, staticRenderFns } from "./tab-sisix.vue?vue&type=template&id=4f70eb72&scoped=true"
import script from "./tab-sisix.vue?vue&type=script&lang=js"
export * from "./tab-sisix.vue?vue&type=script&lang=js"
import style0 from "./tab-sisix.vue?vue&type=style&index=0&id=4f70eb72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70eb72",
  null
  
)

export default component.exports